import "@aws-amplify/ui-react/styles.css";
//import { I18n } from "aws-amplify";
import { I18n } from "aws-amplify/utils";
import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
  Authenticator,
  translations,
  useAuthenticator,
  View,
} from "@aws-amplify/ui-react";

I18n.putVocabularies(translations);

export function Login() {
  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  let from = location.state?.from?.pathname || "/";
  useEffect(() => {
    if (route === "authenticated") {
      navigate(from, { replace: true });
      window.location.reload();
    }
  }, [route, navigate, from]);

  const [seed, setSeed] = useState(1);
  const reset = () => {
    setSeed(Math.random());
  };

  /*
  useEffect(() => {
    I18n.setLanguage(language);
    reset();
  }, [language]);*/

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 1,
      }}
    >
      <View className="auth-wrapper" style={{ marginTop: 150 }}>
        <Typography sx={{ fontSize: 28, mb: 1, width: 1 }} align="center">
          CGI Compass - Sign In
        </Typography>
        <Authenticator hideSignUp={true} key={seed} />
      </View>
      <Button
        sx={{ width: 200, mt: 7 }}
        variant="outlined"
        onClick={() => navigate("/")}
      >
        {t("backHome")}
      </Button>
    </Box>
  );
}
